import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { i18n } from "@/mixins/mixins";


export default /*#__PURE__*/_defineComponent({
  props: {
  data: Object,
  modelValue: {
    type: Number,
    required: false,
  },
  type: String,
  showNetto: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props





return (_ctx: any,_cache: any) => {
  return (props.type == 'monthselect')
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["orm-selectButtonStyle", props.modelValue == parseInt(props.data.value) ? 'active' : '']),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (
      props.modelValue == props.data.value
        ? null
        : emit('update:modelValue', props.data.value)
    ))
      }, [
        _createElementVNode("strong", null, _toDisplayString(props.data.key) + " " + _toDisplayString(_unref(i18n)("general/abo_unit") || "Monate"), 1)
      ], 2))
    : _createCommentVNode("", true)
}
}

})